import AboutLogo from '@/assets/about/about-profile.png';
import Logo from '@/assets/about/logo.png';
import CitySH from '@/assets/about/city-sh.jpg';
import CityWH from '@/assets/about/city-wh.jpg';
import CityCC from '@/assets/about/city-cc.jpg';
import CaHonor from '@/assets/about/ca_honor.png'

export const Feature40DataSource = {
  wrapper: { className: 'home-page-wrapper feature4-wrapper' },
  OverPack: { className: 'home-page feature4' },
  textWrapper: { className: 'feature4-text', xs: 24, md: 12 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'about.excelfore',
      },
      {
        name: 'content',
        className: 'title-content',
        children: 'about.slogan',
      },
    ],
  },
  img: {
    children: AboutLogo,
    className: 'feature4-img',
    xs: 24,
    md: 12,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children: Logo,
          className: 'feature4-icon',
        },
        title: { className: 'feature4-title', children: 'home.aboutTitle' },
        content: {
          className: 'feature4-content',
          children: 'home.aboutContent'
        },
      },
    ],
    measure: [
      {
        md: 8,
        xs: 8,
        className: 'feature4-number-wrapper',
        name: 'child0',
        number: {
          className: 'feature4-number',
          unit: { className: 'feature4-unit', children: 'home.year' },
          toText: true,
          children: '2017',
        },
        children: { className: 'feature4-text', children: 'SINCE' },
      },
      {
        md: 8,
        xs: 8,
        className: 'feature4-number-wrapper',
        name: 'child1',
        number: {
          className: 'feature4-number',
          unit: { className: 'feature4-unit', children: '' },
          toText: true,
          children: '3',
        },
        children: { className: 'feature4-text', children: 'home.researchDevelopmentBase' },
      },
      {
        md: 8,
        xs: 8,
        className: 'feature4-number-wrapper',
        name: 'child2',
        number: {
          className: 'feature4-number',
          unit: { className: 'feature4-unit', children: '+' },
          toText: true,
          children: '60',
        },
        children: { className: 'feature4-text', children: 'home.customerNumber' },
      },
    ]
  },
};
export const Teams10DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'about.collaborativeDevelopment',
      },
      {
        name: 'content',
        className: 'title-content',
        children: 'collaborative development',
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: CitySH
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: 'about.shanghai',
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: '',
            },
            {
              name: 'content1',
              className: 'teams1-content',
              children: 'about.shanghaiAddressDetail',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: CityWH
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: 'about.wuhan',
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: '',
            },
            {
              name: 'content1',
              className: 'teams1-content',
              children: 'about.wuhanAddressDetail',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: CityCC
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: 'about.changchun',
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: '',
            },
            {
              name: 'content1',
              className: 'teams1-content',
              children: 'about.changchunAddressDetail',
            },
          ],
        },
      },
    ],
  },
};

export const Feature60DataSource = {
  wrapper: { className: 'home-page-wrapper feature6-wrapper' },
  // OverPack: { className: 'home-page feature6', playScale: 0.3 },
  Carousel: {
    className: 'feature6-content',
    dots: false,
    wrapper: { className: 'feature6-content-wrapper' },
    titleWrapper: {
      className: 'feature6-title-wrapper',
      barWrapper: {
        className: 'feature6-title-bar-wrapper',
        children: { className: 'feature6-title-bar' },
      },
      title: { className: 'feature6-title' },
    },
    children: [
      {
        title: { className: 'feature6-title-text', children: 'about.domesticCustomer' },
        className: 'feature6-item',
        name: 'block0',
        children: [
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child0',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: '+' },
              toText: true,
              children: '15',
            },
            children: { className: 'feature6-text', children: 'about.coverMajorOems' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child1',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: '+' },
              toText: true,
              children: '100',
            },
            children: { className: 'feature6-text', children: 'about.coverMajorModels' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child2',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: 'W+' },
              toText: true,
              children: '400',
            },
            children: { className: 'feature6-text', children: 'about.totalNumberVehiclesCovered' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child2',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: 'W+' },
              toText: true,
              children: '1000',
            },
            children: { className: 'feature6-text', children: 'about.numberVehicleUpgrades' },
          },
        ],
      },
      {
        title: { className: 'feature6-title-text', children: 'about.foreignCustomer' },
        className: 'feature6-item',
        name: 'block1',
        children: [
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child0',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: '+' },
              toText: true,
              children: '20',
            },
            children: { className: 'feature6-text', children: 'about.coverMajorOems' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child1',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: '+' },
              toText: true,
              children: '60',
            },
            children: { className: 'feature6-text', children: 'about.coverMajorModels' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child2',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: 'W+' },
              toText: true,
              children: '1300',
            },
            children: { className: 'feature6-text', children: 'about.totalNumberVehiclesCovered' },
          },
          {
            md: 6,
            xs: 12,
            className: 'feature6-number-wrapper',
            name: 'child2',
            number: {
              className: 'feature6-number',
              unit: { className: 'feature6-unit', children: 'W+' },
              toText: true,
              children: '2500',
            },
            children: { className: 'feature6-text', children: 'about.numberVehicleUpgrades' },
          },
        ],
      },
    ],
  },
};

export const Feature70DataSource = {
  wrapper: { className: 'home-page-wrapper feature7-wrapper' },
  page: { className: 'home-page feature7' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: 'about.qualificationHonor',
      },
      {
        name: 'content',
        className: 'feature7-title-content',
        children: 'Qualification & Honours',
      },
    ],
  },
  img: {
    children: CaHonor,
    className: 'content6-img',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: 'about.corePatentDetail'
        },
      },
      {
        name: 'block1',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: 'about.2017Awards'
        },
      },
      {
        name: 'block2',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: 'about.2018Awards'
        },
      },
      {
        name: 'block3',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: 'about.2021Awards'
        },
      },
      {
        name: 'block4',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: 'about.2022Awards'
        },
      },
      {
        name: 'block5',
        title: { className: 'content7-title', children: '' },
        content: {
          className: 'content7-content',
          children: '...'
        },
      },
    ],
    measure: [
      {
        md: 12,
        xs: 24,
        className: 'feature6-number-wrapper',
        name: 'child0',
        number: {
          className: 'feature6-number',
          unit: { className: 'feature6-unit', children: '+' },
          toText: true,
          children: '15',
        },
        children: { className: 'feature6-text', children: 'about.softwareLiterature' },
      },
      {
        md: 12,
        xs: 24,
        className: 'feature6-number-wrapper',
        name: 'child1',
        number: {
          className: 'feature6-number',
          unit: { className: 'feature6-unit', children: '+' },
          toText: true,
          children: '8',
        },
        children: { className: 'feature6-text', children: 'about.corePatent' },
      },
    ]
  },
};

export const Content90DataSource = {
  wrapper: { className: 'home-page-wrapper content9-wrapper' },
  page: { className: 'home-page content9' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'about.milestones',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: 'Milestones',
      },
    ],
  },
};

export const PlanDataSource = {
  wrapper: { className: 'home-page-wrapper plan-wrapper' },
  page: { className: 'home-page plan' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
        className: 'title-image',
      },
      {
        name: 'title',
        children: '未来产品规划',
        className: 'title-h1',
      },
    ],
  },
};

export const Content50DataSource = {
  wrapper: { className: 'home-page-wrapper content5-wrapper' },
  page: { className: 'home-page content5' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', children: 'about.cooperativeCustomer', className: 'title-h1' },
      {
        name: 'content',
        className: 'title-content',
        children: 'Partners',
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 16,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img.chebiao.com.cn/uploads/allimg/181020/1-1Q0202149520-L.jpg',
          },
          content: { children: '中国一汽' },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/guochan/1108/1447012_dongfeng.jpg',
          },
          content: { children: '东风' },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://pic.ntimg.cn/file/20160128/13455437_164800102197_2.jpg',
          },
          content: { children: '上汽集团' },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/guochan/1108/1446234_guangqi.jpg',
          },
          content: { children: '广汽集团' },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/guochan/1108/1446234_chaanjiaoche.jpg',
          },
          content: { children: '长安汽车' },
        },
      },
      {
        name: 'block5',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/guochan/1108/1446234_benten.jpg',
          },
          content: { children: '一汽奔腾' },
        },
      },
      {
        name: 'block6',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'http://static.home.baidu.com/homebd/gfjnkambdcileh1565603510.jpg',
          },
          content: { children: '百度' },
        },
      },
      {
        name: 'block7',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://cdn.worldvectorlogo.com/logos/microsoft-5.svg',
          },
          content: { children: '微软' },
        },
      },
      {
        name: 'block8',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://sngedu-punch-1251502357.cos.ap-guangzhou.myqcloud.com/agency_picurl/QFzQYCgCrxkbr601Q0JLnggTyUInClibH5bUzBaCia7NzYSRsCf8ltqV655Cx5hYLM',
          },
          content: { children: '腾讯云' },
        },
      },
      {
        name: 'block9',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://img0.pcauto.com.cn/pcauto/zt/chebiao/meiguo/1108/1446234_ford.jpg',
          },
          content: { children: '福特' },
        },
      },
      {
        name: 'block10',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/deguo/1108/1446234_audi.jpg',
          },
          content: { children: '奥迪' },
        },
      },
      {
        name: 'block11',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://jmc.mu/wp-content/uploads/2021/03/cropped-jmc-new-logo-1.png',
          },
          content: { children: '江铃汽车' },
        },
      },
      {
        name: 'block12',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'http://www.chebiao.cc/uploads/allimg/170319/1_03192340441U3.jpg',
          },
          content: { children: '威马汽车' },
        },
      },
      {
        name: 'block13',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://img0.pcauto.com.cn/pcauto/zt/chebiao/guochan/1108/1328218_yq.png',
          },
          content: { children: '一汽解放' },
        },
      },
      {
        name: 'block14',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://jobs.ynu.edu.cn/attachment/www/avatar/2021/1013/6165c14a90a832.97083954.jpg',
          },
          content: { children: '联友科技' },
        },
      },
      {
        name: 'block15',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'http://mms2.baidu.com/it/u=1457538919,667200934&fm=253&app=138&f=JPEG?w=114&h=114',
          },
          content: { children: 'T3出行' },
        },
      },
      {
        name: 'block16',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://ss1.hao367.com/2010/7584f8c30c18ca1c6c5b4490fa4346ef.jpg',
          },
          content: { children: '岚图汽车' },
        },
      },
      {
        name: 'block17',
        className: 'block',
        md: 4,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://www.globalsuzuki.com/img/common/logo_img.gif',
          },
          content: { children: 'SUZUKI' },
        },
      }
    ],
  },
};
